export default {"src":"/_next/static/media/check.03aa8335.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};